import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../../scss/explain.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moSalaryIndustry from './store';

interface IProps {}
interface IState {}

const Explain = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { overview } = moSalaryIndustry;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="box-15050">
      <strong>解读：</strong>
      <section className="box-151">
        {overview?.map((text: any, index: number) => (
          <p key={index}>
            <span className="ico-11"><b /></span>
            <i>{text}</i>
          </p>
        ))}
      </section>
    </section>
  );
};

export default observer(Explain);
